"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RAIN_PAYMENT_AMOUNT = exports.PREFIX = void 0;
exports.PREFIX = "player";
exports.RAIN_PAYMENT_AMOUNT = 100000; // 1 token with 5 decimals
